import { buildHtml, ContentRoute, RouteSlotInput } from '@caritas/ui';

export function mapSiteSearchBlock(): RouteSlotInput<
  typeof ContentRoute,
  'body',
  'siteSearch'
> {
  return {
    key: 'siteSearch',
    input: () => [
      {
        Content: buildHtml(`<div id="gcse-wrapper" class="gcse-search"></div>`),
      },
      200,
    ],
  };
}
